import { isSuccessStatusCode } from 'owa-http-status-codes';
import type { Logger } from '../utils/logger';
import getDataUrlFromFile from './getDataUrlFromFile';

export default async function getObjectUrlAndDataUrl(
    attachmentUrl: string,
    logger: Logger
): Promise<{ objectUrl: string | null; dataUrl: string | null } | null> {
    let objectUrl: string | null = null;
    let dataUrl: string | null = null;
    let response;
    try {
        response = await fetch(attachmentUrl);
    } catch {
        logger('showImage', 'failToFetchImage');
        return null;
    }

    if (response && isSuccessStatusCode(response.status)) {
        let blob;
        try {
            blob = await response.blob();
        } catch (error) {
            logger('showImage', 'failToCreateFileBlob');
            return null;
        }
        objectUrl = URL.createObjectURL(blob);
        dataUrl = await getDataUrlFromFile(blob);
    } else {
        logger('showImage', 'failToFetchImage');
    }

    return { objectUrl, dataUrl };
}
